/**
 * @module manifest/panelLayout/resolveLayout
 * @description 将 panelLayout 中的组 id 解析为带显隐的 LayoutGroupWithVisibility
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import { REGISTERED_GROUP_BY_ID } from '../groupRegistryDefs';
import type { LayoutGroupWithVisibility, PanelTabLayout } from './types';

/** 单 Tab 内组 id 列表 → evaluateVisibility 所需结构 */
export function layoutToResolvedGroupsForIds(
  chartType: TChartType,
  groupIds: readonly string[],
): LayoutGroupWithVisibility[] {
  return groupIds.map(groupId => {
    const definition = REGISTERED_GROUP_BY_ID[groupId];
    const chartVis = definition?.chartVisibility?.[chartType];

    return {
      id: groupId,
      visible: chartVis?.visible,
      itemsVisibility: chartVis?.itemsVisibility
        ? { ...chartVis.itemsVisibility }
        : undefined,
    };
  });
}

/** 图表全部 Tab → 扁平列表（formDelKey / 跨 Tab 显隐预计算） */
export function layoutToResolvedGroups(
  chartType: TChartType,
  tabs: readonly PanelTabLayout[],
): LayoutGroupWithVisibility[] {
  return tabs.flatMap(tab =>
    layoutToResolvedGroupsForIds(chartType, tab.groups),
  );
}

